import React, { PropTypes, Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import {formatTelefone, inteiroPositivo, alphanumeric} from "../../../../utils/formatar";
import moment from "moment/moment";
import DatePicker from "react-datepicker";
import {Validacao} from "../../../comum/components/Validacao";

@inject("store")
@observer
export class NotaFiscalForm extends Component {
    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }

    render() {
        const pagamento = this.controller.pagamento;
        return (
            <div>
                <h4>Nota fiscal</h4>
                <Row>
                    <Col xs={12} md={4} lg={3}>
                        <FormGroup>
                            <Label>Número <sup>*</sup></Label>
                            <Input type="text" value={pagamento.numero} onChange={(event) => this.controller.setNumero(inteiroPositivo(event.target.value))} maxLength={18} />
                            <Validacao id="numeroPagamento" valor={pagamento.numero} tipo={["isRequired"]} />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={3}>
                        <FormGroup>
                            <Label>Data de emissão <sup>*</sup></Label>
                            <DatePicker
                                ref="dataEmissao"
                                onClickOutside={()=>{this.refs.dataEmissao.cancelFocusInput(); this.refs.dataEmissao.setOpen(false);}}
                                locale={"pt_BR"}
                                className="form-control"
                                dateFormat="DD/MM/YYYY"
                                selectsStart
                                selected={pagamento.dataEmissao}
                                onChange={(value) => this.controller.setDataEmissao(value)}
                                maxDate={moment()}
                                onChangeRaw={(e) => this.controller.checkDataEmissao(e.target.value)}/>
                            <Validacao id="dataEmissao" valor={this.controller.dataEmissaoValidacao} tipo={["isRequired", "isDate", "compararDataPosterior",moment()]}/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={3}>
                        <FormGroup>
                            <Label>Data de vencimento <sup>*</sup></Label>
                            <DatePicker
                                ref="dataVencimento"
                                onClickOutside={()=>{this.refs.dataVencimento.cancelFocusInput(); this.refs.dataVencimento.setOpen(false);}}
                                locale={"pt_BR"}
                                className="form-control"
                                dateFormat="DD/MM/YYYY"
                                selectsStart
                                selected={pagamento.dataVencimento}
                                minDate={new Date()}
                                onChange={(value) => this.controller.setDataVencimento(value)}
                                onChangeRaw={(e) => this.controller.checkDataVencimento(e.target.value)}/>
                            <Validacao id="dataVencimento" valor={this.controller.dataVencimentoValidacao} tipo={["isRequired", "isDate", "endDateSameOrAfter", this.controller.dataEmissaoValidacao]} mensagem={{endDateSameOrAfter: "Data de vencimento inferior à data de emissão"}}/>
                            <Validacao id="dataVencimentoMenorDataAtual" valor={this.controller.dataVencimentoValidacao} tipo={["endDateSameOrAfter", moment().startOf('day')]} mensagem={{endDateSameOrAfter: "Data de vencimento inferior à data atual"}}/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={3}>
                        <FormGroup>
                            <Label>Série <sup>*</sup></Label>
                            <Input type="text" value={pagamento.serie} onChange={(event) => this.controller.setSerie(alphanumeric(event.target.value))} maxLength={25} />
                            <Validacao id="seriePagamento" valor={pagamento.serie} tipo={["isRequired"]} />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}